import React from 'react'

const Footer = () => {
  return (
    <div>
    <footer class="bg-blue-900 text-white text-center lg:text-left">
  <div class=" text-center font-extrabold py-4">
    © 2022 Copyright:
    <a class=" font-extrabold" href="#">Foody</a>
  </div>
</footer>
      
    </div>
  )
}

export default Footer
